
export default (store) => ({
  path: 'onboarding',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Onboarding = require('./components/Onboarding').default

      /*  Return getComponent   */
      cb(null, Onboarding)

    /* Webpack named bundle   */
    }, 'Onboarding')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/HealthAndHappinessTool/routes/Onboarding/index.js
 **/